// extracted by mini-css-extract-plugin
export default {"button":"styles_button__3ItTZ","button_close":"styles_button_close__mF0pa","button_text":"styles_button_text__WWL+h"};